import { useEffect, useState } from "react";
import { Flex, Button } from "antd";
import CardThemePalette from "../CardThemePalette";

import StyledModal from "./style";

import { LIST_THEME } from "../../constant";

const ModalSettingsTheme = ({
  activeThemeId,
  loading,
  onCancel,
  onSuccess,
  open,
}) => {
  const [selectedThemeId, setSelectedThemeId] = useState();

  useEffect(() => {
    if (!open || !activeThemeId) return;

    setSelectedThemeId(activeThemeId);
  }, [activeThemeId, open]);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            onClick={() =>
              onSuccess(LIST_THEME.find(it => it.id === selectedThemeId))
            }
            shape="round"
            type="primary"
          >
            Update
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title="Color Theme"
      width={647}
    >
      <p style={{ margin: "0 0 32px", width: 450 }}>
        Pick a color theme that fits your brand. Reach out to our customer
        engagement team for custom solutions.
      </p>
      <Flex gap={16} vertical>
        {LIST_THEME.map(it => (
          <CardThemePalette
            isActive={it.id === selectedThemeId && "active"}
            key={it.id}
            onClick={() => setSelectedThemeId(it.id)}
            themeData={it}
          />
        ))}
      </Flex>
    </StyledModal>
  );
};

export default ModalSettingsTheme;
